import { useEffect, useState } from 'react';

import { trackCandidateCardStatus } from 'src/utils/events';

type DisclosureState =
  | {
      hasRoleRequirements: true;
      isExpanded: boolean;
    }
  | {
      hasRoleRequirements: false;
      isExpanded: undefined;
    };

type Params = {
  roleRequirementsLength: number;
  applicationListState: 'expanded' | 'collapsed';
};

// FIX ME: Team to have discussion about hooks in a different file https://github.com/SEEK-Jobs/cm-ui/pull/3667#discussion_r2160763097
export const useRoleRequirementsDisclosure = ({
  roleRequirementsLength,
  applicationListState,
}: Params) => {
  const [disclosure, setDisclosure] = useState<DisclosureState>(() =>
    roleRequirementsLength > 0
      ? {
          hasRoleRequirements: true,
          isExpanded: applicationListState === 'expanded',
        }
      : {
          hasRoleRequirements: false,
        },
  );

  const toggleIsExpanded = () => {
    if (disclosure.hasRoleRequirements) {
      const newState = !disclosure.isExpanded;
      setDisclosure((prev) => ({
        ...prev,
        hasRoleRequirements: true,
        isExpanded: newState,
      }));
      trackCandidateCardStatus({
        actionOrigin: 'Candidate Listing - Individual Card Change',
        candidateCardStatus: newState ? 'Expand' : 'Collapse',
      });
    }
  };

  useEffect(() => {
    if (disclosure.hasRoleRequirements) {
      setDisclosure((prev) => ({
        ...prev,
        hasRoleRequirements: true,
        isExpanded: applicationListState === 'expanded',
      }));
    }
  }, [applicationListState, disclosure.hasRoleRequirements]);

  return {
    isRoleRequirementsDisclosureExpanded: Boolean(disclosure.isExpanded),
    hasRoleRequirements: disclosure.hasRoleRequirements,
    roleRequirementsDiscloserOnClick: toggleIsExpanded,
  };
};
